export const SET_IS_LOADING = 'SCHEDULING_CONFIGURATIONS/SET_IS_LOADING';
export const SET_SCHEDULING_CONFIGURATION = 'SCHEDULING_CONFIGURATIONS/SET_SCHEDULING_CONFIGURATION';
export const CLEAR_SCHEDULING_CONFIGURATION = 'SCHEDULING_CONFIGURATIONS/CLEAR_SCHEDULING_CONFIGURATION';